'use strict';

/*!
 * Tokai Univ Search
 *
 * @handle tokai-univ-search
 * @version 0.0.0
 * @footer true
 * @deps jquery, wp-api-request
 */

const $ = jQuery;
const { apiRequest } = wp;
const min_str_length_for_search = 2;
const incremental_search_delay = 500;

/**
 * Fetch request.
 *
 * @param {string} s Search string.
 * @returns {*} Fetch object.
 */
const fetchSuggests = s => {
	return apiRequest( {
		path: '/tokai-univ-search/v1/suggests?s=' + encodeURIComponent( s ),
	} );
};

const appendListItem = ( $list, text, href, callback ) => {
	const $anchor = $( `<a type="button">${text}</a>` );
	const $item = $( '<li class="search-form-suggest-item"></li>' );
	$item.append( $anchor );
	$list.append( $item );
	$anchor.click( callback );
};

$( document ).ready( () => {
	const $forms = $( '.with-suggest' );
	$forms.each( ( _0, form ) => {
		const $form = $( form );
		const $container = $( '<div class="search-form-suggest"></div>' );
		const $ul = $( '<ul class="search-form-suggest-list"></ul>' );
		$container.hide();
		$container.append( $ul );
		$form.after( $container );
		const $search_field = $form.find( '.suggest-source' );

		// fire incremental search if needed
		let timer_id;
		$search_field
			.keyup( e => {
				if ( timer_id ) {
					clearTimeout( timer_id );
				}
				timer_id = setTimeout( () => {
					const s = e.target.value;
					if ( s.replace( /\s/g, '' ).length > min_str_length_for_search - 1 ) {
						fetchSuggests( s ).done( posts => {
							const post_titles = posts.map( post => {
								return {
									post_title: post.post_title,
									permalink: post.permalink,
								};
							} );
							$ul.empty();
							post_titles.forEach( ( { post_title, permalink } ) =>
								appendListItem( $ul, post_title, permalink, () => {
									$search_field.val( post_title );
									$container.hide();
									$ul.empty();
									$form.submit();
								} )
							);
							if ( post_titles.length > 0 ) {
								$container.show();
							} else {
								$container.hide();
							}
						} ).fail( function () {
							$container.hide();
						} );
					} else {
						$container.hide();
						$ul.empty();
					}
				}, incremental_search_delay );
			} );
	} );
} );
